import React from 'react';
import { connect } from 'react-redux';
import { link_click } from '../../../redux/actions';
import ReportLauncherPage from '../../ReportLauncher/ReportLauncherPage';
import buildFinanceReportsSections from './FinanceReportsSections';

class FinanceReportsAdmin extends React.Component {
  static defaultProps = {
    OpportunityId: 0,
  };

  render() {
    return <ReportLauncherPage sections={buildFinanceReportsSections(this.props.link_click)} />;
  }
}

export default connect(null, { link_click })(FinanceReportsAdmin);
